import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export default class SplideInit {
    static init(): void {
        const splideLogoElements = document.querySelectorAll<HTMLElement>('.js-splide-logo');
        if (!splideLogoElements.length) return;

        const options = { rootMargin: "50% 0%" };
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!(entry.target instanceof HTMLElement)) return;
                if (!entry.isIntersecting) return;
                observer.unobserve(entry.target);
                this.splideLogo(entry.target);
            });
        }, options);

        setTimeout(() => {
            splideLogoElements.forEach(
                (element) => observer.observe(element)
            );
        }, 0);
    }

    static splideLogo(splideLogoElement: HTMLElement): void {
        const splide = new Splide(splideLogoElement, {
            type: 'loop',
            drag: 'free',
            focus: 'center',
            gap: 75,
            arrows: false,
            pagination: false,
            autoWidth: true,
            clones: 8,
            //perPage: 3,
            autoScroll: {
                speed: 1,
                pauseOnHover: false, // Toto zastaví autoscroll při hoveru
            },
        });

        splide.mount({ AutoScroll });
    }
}
